import { Fragment, ReactNode } from "react";
import styled from "styled-components";

type PolicyDetailTypes = {
  title: string;
  detail: ReactNode;
};

type PolicyPanelProps = {
  items: PolicyDetailTypes[];
};

const PolicyPanelWrapper = styled.dl`
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 0.2rem solid #000;

  & > .txt_title {
    position: relative;
    margin-top: 2rem;
    padding-left: 1.2rem;
    font-weight: 700;
    line-height: 2.2rem;
  }

  & > .txt_title::before {
    position: absolute;
    top: 0.8rem;
    left: 0;
    width: 0.6rem;
    height: 0.6rem;
    background-color: #000;
    border-radius: 100%;
    content: "";
  }

  .policy_detail {
    margin-top: 1rem;
    padding-left: 1.2rem;
    line-height: 2.2rem;
  }

  .item_control_detail {
    margin-top: 2rem;
    padding: 3rem 0 0;
    border-top: 1px solid #c9c9c9;
  }

  .item_control_detail:first-child {
    padding-top: 2rem;
  }

  .item_control_detail .txt_title {
    line-height: 1.7rem;
    font-size: 1.4rem;
    font-weight: 700;
  }

  .item_control_detail .txt_title .txt_em {
    color: #e10032;
  }

  .item_control_detail .btn_detail {
    display: inline-block;
    padding: 0.5rem 1.2rem;
    border: 1px solid #c8d2e0;
    border-radius: 0.5rem;
    color: #454557;
    font-size: 1.4rem;
    line-height: 1.8rem;
  }

  .list_web {
    margin-top: 1rem;
  }

  .list_web .item {
    position: relative;
    line-height: 3rem;
  }

  .list_web .item + .item {
    margin-top: 1.4rem;
  }

  .list_web .item .btn_detail {
    position: absolute;
    top: 50%;
    left: 8rem;
    margin-top: -1.5rem;
  }

  .list_app {
    margin-bottom: 4.2rem;
    font-size: 1.4rem;
  }

  .list_app .item {
    margin-bottom: 1rem;
    padding: 1rem 0 2rem;
    border-bottom: 1px solid #ececec;
  }

  .list_app .txt_subtitle {
    font-weight: 700;
  }

  .list_app .txt_subtitle + .txt {
    margin: 0.4rem 0 1rem;
  }

  .list_app .form_radio .c_radio {
    flex-basis: 5.7rem;
    margin-top: 2rem;
  }

  .list_noti li {
    margin-top: 1rem;
  }

  .list_noti li::before {
    content: "※ ";
  }

  .list_noti li.txt_red {
    color: #e10032;
  }
`;

const PolicyPanel = ({ items }: PolicyPanelProps) => {
  return (
    <>
      <PolicyPanelWrapper>
        {items.map((item, idx) => (
          <Fragment key={idx}>
            <dt className="txt_title">{item.title}</dt>
            <dl className="policy_detail">{item.detail}</dl>
          </Fragment>
        ))}
      </PolicyPanelWrapper>{" "}
    </>
  );
};

export default PolicyPanel;
